"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Private = exports.Route = exports.Router = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _getIteratorMethod2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/get-iterator-method"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _internal = require("./internal");

function _createForOfIteratorHelper(o) { if (typeof _symbol.default === "undefined" || (0, _getIteratorMethod2.default)(o) == null) { if ((0, _isArray.default)(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2.default)(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context8; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = (0, _slice.default)(_context8 = Object.prototype.toString.call(o)).call(_context8, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from.default)(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Route = function Route() {
  return null;
};
/**
 * `Routes` nested in `Private` require authentication.
 * When a user is not authenticated and attempts to visit this route they will be
 * redirected to `unauthenticated` route.
 */


exports.Route = Route;

var Private = function Private() {
  return null;
};

exports.Private = Private;
Private.propTypes = {
  /**
   * The page name where a user will be redirected when not authenticated.
   */
  unauthenticated: _propTypes.default.string.isRequired
};

var PrivatePageLoader = function PrivatePageLoader(_ref) {
  var useAuth = _ref.useAuth,
      unauthenticatedRoute = _ref.unauthenticatedRoute,
      children = _ref.children;

  var _useAuth = useAuth(),
      loading = _useAuth.loading,
      authenticated = _useAuth.authenticated;

  if (loading) {
    return null;
  }

  if (authenticated) {
    return children;
  } else {
    return /*#__PURE__*/_react.default.createElement(_internal.Redirect, {
      to: unauthenticatedRoute()
    });
  }
};

var Router = function Router(props) {
  return /*#__PURE__*/_react.default.createElement(_internal.Location, null, function (locationContext) {
    return /*#__PURE__*/_react.default.createElement(RouterImpl, (0, _extends2.default)({}, locationContext, props));
  });
};
/**
 * Pages can be imported automatically or manually. Automatic imports are actually
 * objects and take the following form (which we call a 'spec'):
 *
 *   const WhateverPage = {
 *     name: 'WhateverPage',
 *     loader: () => import('src/pages/WhateverPage')
 *   }
 *
 * Manual imports simply load the page:
 *
 *   import WhateverPage from 'src/pages/WhateverPage'
 *
 * Before passing a "page" to the PageLoader, we will normalize the manually
 * imported version into a spec. */


exports.Router = Router;

var normalizePage = function normalizePage(specOrPage) {
  if (specOrPage.loader) {
    // Already a spec, just return it.
    return specOrPage;
  } else {
    // Wrap the Page in a fresh spec, and put it in a promise to emulate
    // an async module import.
    return {
      name: specOrPage.name,
      loader: function () {
        var _loader = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    default: specOrPage
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function loader() {
          return _loader.apply(this, arguments);
        }

        return loader;
      }()
    };
  }
};

var DEFAULT_PAGE_LOADING_DELAY = 1000; // milliseconds

var RouterImpl = function RouterImpl(_ref2) {
  var _context2, _context3, _context4, _context6, _context7;

  var pathname = _ref2.pathname,
      search = _ref2.search,
      paramTypes = _ref2.paramTypes,
      _ref2$pageLoadingDela = _ref2.pageLoadingDelay,
      pageLoadingDelay = _ref2$pageLoadingDela === void 0 ? DEFAULT_PAGE_LOADING_DELAY : _ref2$pageLoadingDela,
      children = _ref2.children,
      _ref2$useAuth = _ref2.useAuth,
      useAuth = _ref2$useAuth === void 0 ? window.__REDWOOD__USE_AUTH : _ref2$useAuth;
  // Find `Private` components, mark their children `Route` components as private,
  // and merge them into a single array.
  var privateRoutes = (0, _reduce.default)(_context2 = (0, _map.default)(_context3 = (0, _filter.default)(_context4 = _react.default.Children.toArray(children)).call(_context4, function (child) {
    return child.type === Private;
  })).call(_context3, function (privateElement) {
    var _context5;

    // Set `Route` props
    var _privateElement$props = privateElement.props,
        unauthenticated = _privateElement$props.unauthenticated,
        children = _privateElement$props.children;
    return (0, _map.default)(_context5 = _react.default.Children.toArray(children)).call(_context5, function (route) {
      return _react.default.cloneElement(route, {
        private: true,
        unauthenticatedRedirect: unauthenticated
      });
    });
  })).call(_context2, function (a, b) {
    return (0, _concat.default)(a).call(a, b);
  }, []) || [];
  var routes = (0, _concat.default)(_context6 = []).call(_context6, (0, _toConsumableArray2.default)(privateRoutes), (0, _toConsumableArray2.default)((0, _filter.default)(_context7 = _react.default.Children.toArray(children)).call(_context7, function (child) {
    return child.type === Route;
  })));
  var namedRoutes = (0, _internal.mapNamedRoutes)(routes);
  var NotFoundPage;

  var _iterator = _createForOfIteratorHelper(routes),
      _step;

  try {
    var _loop = function _loop() {
      var route = _step.value;
      var _route$props = route.props,
          path = _route$props.path,
          Page = _route$props.page,
          redirect = _route$props.redirect,
          notfound = _route$props.notfound;

      if (notfound) {
        NotFoundPage = Page;
        return "continue";
      }

      var _matchPath = (0, _internal.matchPath)(path, pathname, paramTypes),
          match = _matchPath.match,
          pathParams = _matchPath.params;

      if (match) {
        var searchParams = (0, _internal.parseSearch)(search);
        var allParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, pathParams), searchParams);

        if (redirect) {
          var newPath = (0, _internal.replaceParams)(redirect, pathParams);
          (0, _internal.navigate)(newPath);
          return {
            v: /*#__PURE__*/_react.default.createElement(RouterImpl, {
              pathname: newPath,
              search: search
            }, children)
          };
        } else {
          var _route$props2;

          var Loaders = function Loaders() {
            return /*#__PURE__*/_react.default.createElement(_internal.ParamsContext.Provider, {
              value: allParams
            }, /*#__PURE__*/_react.default.createElement(_internal.PageLoader, {
              spec: normalizePage(Page),
              delay: pageLoadingDelay,
              params: allParams
            }));
          };

          if (route === null || route === void 0 ? void 0 : (_route$props2 = route.props) === null || _route$props2 === void 0 ? void 0 : _route$props2.private) {
            if (typeof useAuth === 'undefined') {
              throw new Error("You're using a private route, but `useAuth` is undefined. Have you created an AuthProvider, or pased in the incorrect prop to `useAuth`?");
            }

            return {
              v: /*#__PURE__*/_react.default.createElement(PrivatePageLoader, {
                useAuth: useAuth,
                unauthenticatedRoute: namedRoutes[route.props.unauthenticatedRedirect]
              }, /*#__PURE__*/_react.default.createElement(Loaders, null))
            };
          }

          return {
            v: /*#__PURE__*/_react.default.createElement(Loaders, null)
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      switch (_ret) {
        case "continue":
          continue;

        default:
          if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
      }
    } // If the router is being used in a Redwood app and only the notfound page is
    // specified, show the Redwood splash page.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (routes.length === 1 && NotFoundPage) {
    var isRedwood = typeof __REDWOOD__ !== 'undefined';
    return /*#__PURE__*/_react.default.createElement(_internal.SplashPage, {
      isRedwood: isRedwood
    });
  }

  return /*#__PURE__*/_react.default.createElement(_internal.ParamsContext.Provider, {
    value: {}
  }, /*#__PURE__*/_react.default.createElement(_internal.PageLoader, {
    spec: normalizePage(NotFoundPage)
  }));
};